// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-module--modal--2SNGh","show":"modal-module--show--fQR_w","close":"modal-module--close--16iAO"};